import { CloudDownloadOutlined } from '@ant-design/icons';
import React from 'react';
import styled from 'styled-components';

import DrawerButton from 'components/Views/Creative/Drawers/DrawerButton';
import type Asset from 'stores/Asset';
import { offerDownload } from 'utils/Download';

const CloudDownloadIcon = styled(CloudDownloadOutlined)`
  font-size: 20px;
  padding-top: 4px;
`;

export interface DownloadFileButtonProps {
  asset: Asset;
}

function DownloadFileButton({ asset }: DownloadFileButtonProps) {
  return (
    <DrawerButton
      disabled={asset.loading}
      onClick={() => {
        void offerDownload(asset.downloadURL, asset.filename);
      }}
    >
      <CloudDownloadIcon />
    </DrawerButton>
  );
}

export default DownloadFileButton;
